import { Csv } from 'resources/resource'

export function gotAvailableData(fields, positions) {
	return {
		type: "GOT_AVAILABLE_CSV_DATA",
		fields,
		positions, 
	}
}

export function getAvailableData(queryString) {
	return dispatch => {
		return new Csv().getAvailableData(queryString).then(response => {
			return response.json().then(data => {
				return dispatch(gotAvailableData(data.fields, data.positions))
			})
		})
	}
}

